import { JSX } from 'react';
import {
    Show,
    SimpleShowLayout,
    TextField,
    required,
    useRecordContext,
    SelectField,
    ReferenceField,
    DateField,
    Pagination,
    Datagrid,
    ShowButton,
    EditButton,
    ReferenceManyField,
} from 'react-admin';
import { useActiveStatus } from "../../defaults/defaults";
import {Box, Grid} from "@mui/material";
import { CompaniesHouse } from "../../types/entities";

const ShowTitle = () => {
    const record: CompaniesHouse = useRecordContext();
    if (!record) return null;
    return (
        <span>
            { 'Companies House - ' + record.companyName }
        </span>
    );
}

export const AdminCompaniesHouseShow = () => {
    const statuses = useActiveStatus();
    return (
        <Box sx={ { flexGrow: 1, padding: '0 16px 0 16px' } }>
            <Grid container spacing={ 2 }>
                <Grid size={ 12 }>
                    <Show title={ <ShowTitle /> } >
                        <Grid size={ 12 }>
                            <Grid container spacing={ 2 }>
                                <Grid size={ 6 }>
                                    <SimpleShowLayout>
                                        <TextField source="type" />
                                        <SelectField
                                            source="status"
                                            choices={ statuses }
                                            optionValue="id"
                                        />
                                        <DateField source="incorporatedOn" />
                                    </SimpleShowLayout>
                                </Grid>
                                <Grid size={ 6 }>
                                    <SimpleShowLayout>
                                        <DateField source="previousAccounts"  />
                                        <DateField source="nextAccounts" />
                                        <DateField source="nextAccountsDue"  />
                                    </SimpleShowLayout>
                                </Grid>
                            </Grid>
                            <Grid container spacing={ 2 }>
                                <Grid size={ 6 }>
                                    <SimpleShowLayout>
                                        <DateField source="previousConfirmationStatement"  />
                                        <DateField source="nextConfirmationStatement"  />
                                        <DateField source="nextConfirmationStatementDue"  />

                                    </SimpleShowLayout>
                                </Grid>
                                <Grid size={ 6 }>
                                    <SimpleShowLayout>
                                        <ReferenceField
                                            label="Company"
                                            source="company"
                                            reference="companies"
                                        >
                                            <TextField source="name"/>
                                        </ReferenceField>
                                    </SimpleShowLayout>
                                </Grid>
                            </Grid>
                        </Grid>
                    </Show>
                </Grid>
            </Grid>

            <Grid container spacing={ 2 }>
                <Grid size={ 6 }>
                    <Show title=" " actions={ false } >
                        <Box sx={ { padding: '5px 10px 5px 10px', fontSize: '24px' } }>
                            <span>Filings</span>
                        </Box>
                        <ReferenceManyField
                            label="Filing History"
                            source="filingHistory"
                            reference="companies_house_filing"
                            target="id"
                            pagination={ <Pagination /> }
                        >
                            <Datagrid bulkActionButtons={ false } >
                                <TextField source="id" />
                                <TextField source="type" />
                                <TextField source="description" />
                                <>
                                    <ShowButton />
                                    <EditButton />
                                </>
                            </Datagrid>
                        </ReferenceManyField>
                    </Show>
                </Grid>
                <Grid size={ 6 }>
                    <Show title=" " actions={ false } >
                        <Box sx={ { padding: '5px 10px 5px 10px', fontSize: '24px' } }>
                            <span>People</span>
                        </Box>
                        <ReferenceManyField
                            label="People"
                            source="people"
                            reference="companies_house_people"
                            target="id"
                            pagination={ <Pagination /> }
                        >
                            <Datagrid bulkActionButtons={ false } >
                                <TextField source="id" />
                                <TextField source="name" />
                                <TextField source="role" />
                                <>
                                    <ShowButton />
                                    <EditButton />
                                </>
                            </Datagrid>
                        </ReferenceManyField>
                    </Show>
                </Grid>
            </Grid>
            <Grid container spacing={ 2 }>
                <Grid size={ 6 }>
                    <Show title=" " actions={ false } >
                        <Box sx={ { padding: '5px 10px 5px 10px', fontSize: '24px' } }>
                            <span>Addresses</span>
                        </Box>
                        <ReferenceManyField
                            label="Addresses"
                            source="addresses"
                            reference="companies_house_address"
                            target="id"
                            pagination={ <Pagination /> }
                        >
                            <Datagrid bulkActionButtons={ false } >
                                <TextField source="id" />
                                <TextField source="line_one" />
                                <TextField source="postcode" />
                                <>
                                    <ShowButton />
                                    <EditButton />
                                </>
                            </Datagrid>
                        </ReferenceManyField>
                    </Show>
                </Grid>
            </Grid>
        </Box>
    );
}